import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/star-wish/Index.vue')
const Records = () => import('../activity/star-wish/Records.vue')
const Rewards = () => import('../activity/star-wish/Rewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/star-wish',
  name: 'activity_star_wish',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '年度星愿季',
  },
}

export const recordsRoute: RouteConfig = {
  path: '/activity/star-wish/records',
  name: 'activity_star_wish_records',
  component: Records,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '星愿币明细',
  },
}

export const rewardsRoute: RouteConfig = {
  path: '/activity/star-wish/rewards',
  name: 'activity_star_wish_rewards',
  component: Rewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的兑换商品',
  },
}

export default [indexRoute, recordsRoute, rewardsRoute]
